import React from 'react';
import { connect } from 'react-redux';
import CommunityTabComponent from './CommunityTabComponent';
import {
  chatFeedActions,
  chatFeedOperations,
  chatFeedSelectors,
} from '../CommunityMergeFeed/ChatFeed/duck';
import { appActions } from 'App/duck';
import { userManagementOperations } from '../UserManagement/duck';

const mapStateToProps = ({ appReducer, setupReducer, locationReducer }) => ({
  locationSettings: appReducer.location.settings,
  locationId: locationReducer.location_code,
  locations: locationReducer.locations,
  managers: appReducer.managers.users,
  associates: appReducer.associates.users,
  shouldDisableDm: setupReducer.setup_actions.meta.current_location.cfg_not_dm,
  shouldDisableGroupCreate: appReducer.location.settings.cfg__group_chat__private_group__create,
});



const mapDispatchToProps = (dispatch) => {
  const createChatSession = (selectedUserId, currentUserId, locationId) => {
    dispatch(chatFeedOperations.createChatSession(selectedUserId, currentUserId, locationId));
  };

  const createChannel = (groupName, locationId, description) => {
    dispatch(userManagementOperations.createGroup(groupName, locationId, description));
  };

  return {
    createChatSession,
    createChannel
  };
};


const CommunityTabContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)((props) => (
  <CommunityTabComponent
    {...props}
  />
));

export default CommunityTabContainer;